import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { DraftTrackerEmbeddable } from '../DraftTrackerEmbeddable';

export const DraftTrackerEmdbeddableProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <DraftTrackerEmbeddable {...data} />
        </Provider>
    );
};

DraftTrackerEmdbeddableProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.shape({
        title: PropTypes.string,
        linkTo: PropTypes.string,
        linkToLabel: PropTypes.string,
        seasonToShow: PropTypes.string.isRequired,
        numberOfPlayers: PropTypes.string.isRequired,
        clubPid: PropTypes.string,
        sponsorText: PropTypes.string,
        sponsorImage: PropTypes.string,
        leaderboard: PropTypes.array,
        status: PropTypes.any
    })
};
